const Config = {
    apiKey: "AIzaSyAT35a6wJBeM4T92b0vHyLefh5QzTC92NA",
    authDomain: "mentalhealth-2e530.firebaseapp.com",
    databaseURL: "https://mentalhealth-2e530.firebaseio.com",
    projectId: "mentalhealth-2e530",
    storageBucket: "mentalhealth-2e530.appspot.com",
    messagingSenderId: "928659331136",
    appId: "1:928659331136:web:2b058e4fc5607638c3e7a5",
    measurementId: "G-EHD7XP7RQZ"
};

export default Config;